import React from "react";
import "./Contact.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import {contactInfo} from "../../portfolio";
import {Fade} from "react-reveal";

export default function Contact() {
  return (
    <section className="section" id="contact">
      <div className="container">
        <Fade bottom duration={1000} distance="20px">
          <div className="contact-header">
            <p className="typography-eyebrow mb-2">Get In Touch</p>
            <h2 className="section-title mb-3">{contactInfo.title}</h2>
            <p className="section-subtitle mb-5">{contactInfo.subtitle}</p>
          </div>
          <div className="contact-text-div">
            <a
              className="contact-detail-email"
              href={"mailto:" + contactInfo.email_address}
            >
              <i className="fas fa-envelope"></i>
              {contactInfo.email_address}
            </a>
            <SocialMedia />
          </div>
        </Fade>
      </div>
    </section>
  );
}
